import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { DocumentSearchResults } from '2-feature/Search/DocumentSearchResults';
interface Props extends Content.Page {
	properties: Content.DocumentCatalogPageProperties;
}

export const DocumentCatalogPage = ({ properties }: Props) => {
	const {
		pageHeader,
		documents,
		totalDocuments,
		facets,
		subjectTagsFilterLabel,
		statusTagsFilterLabel,
		typeTagsFilterLabel,
		dateFilterLabel,
		siteTags,
	} = properties ?? {};
	return (
		<MainRegion
			header={pageHeader.map((headerModule, index) => (
				<DynamicModule key={index} module={headerModule} />
			))}
		>
			<div className="u-visually-hidden" dangerouslySetInnerHTML={{ __html: '<!--cludooff: index-->' }} />
			<DocumentSearchResults
				serverSideDocuments={documents}
				facets={facets}
				totalDocuments={totalDocuments}
				labels={{
					subjectFilter: subjectTagsFilterLabel,
					statusFilter: statusTagsFilterLabel,
					typeFilter: typeTagsFilterLabel,
					dateFilter: dateFilterLabel,
				}}
				tags={siteTags}
			/>
			<div className="u-visually-hidden" dangerouslySetInnerHTML={{ __html: '<!--cludoon: index-->' }} />
			<GoToTopNavigation />
		</MainRegion>
	);
};
